module.exports = __webpack_public_path__ + "static/manuel-meurisse-5c8fczgvar0-unsplash-8fbe43acd7cfc7548d2a924da89aa7e1.png";